export const SET_TURN_COLOR = 'SET_TURN_COLOR';
export const GET_TURN = 'GET_TURN';
export const CLEAR_TURN_COLOR = 'CLEAR_TURN_COLOR';
export const CORRECT_ANSWER = 'CORRECT_ANSWER';
export const GET_QUESTIONS = 'GET_QUESTIONS';
export const REMOVE_QUESTION = 'REMOVE_QUESTION';
export const QUESTION_ERROR = 'QUESTION_ERORR';
export const GAME_OVER = 'GAME_OVER';
export const INIT_GAME = 'INIT_GAME';
export const GET_STORAGE = 'GET_STORAGE';
export const SET_DICE = 'SET_DICE';

